import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelTokens = {
  editJobLocation: null,
};

class OpportunityJobLocationService {
  selectTenderDeliveryLocation({ opportunityId }) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/opportunities/${opportunityId}/job-location/from-tender`,
    ).then((response) => response.data);
  }

  editOpportunityJobLocation({ opportunityId, jobLocation }) {
    if (cancelTokens.editJobLocation) cancelTokens.editJobLocation.cancel('Multiple requests.');
    cancelTokens.editJobLocation = CancelToken.source();

    return ApiService.put(`${Config.api.document.url}api/v1/opportunities/${opportunityId}/job-location`, jobLocation, {
      cancelToken: cancelTokens.editJobLocation.token,
    }).then((response) => response.data);
  }
}

export const opportunityJobLocationService = new OpportunityJobLocationService();
